import type { NavigationItem, PermissionSet } from "../../types/auth"
import { apiFetch } from "../client"

export interface AuthUser {
  userId: string
  fullName: string
  role: string
  phoneNumber: string
  email?: string | null
  teamName?: string | null
  permissions?: PermissionSet
  navigation?: NavigationItem[]
  defaultPath?: string
}

export async function requestOtp(phoneNumber: string) {
  return apiFetch<{ status: string; data: { message: string; expiresIn: number } }>(
    "/auth/otp/request",
    {
      method: "POST",
      rawBody: { phoneNumber, loginScope: "STAFF" },
    },
  )
}

export async function verifyOtp(phoneNumber: string, otp: string) {
  return apiFetch<{
    status: string
    data: {
      sessionToken: string
      expiresAt: string
      user: AuthUser
    }
  }>("/auth/otp/verify", {
    method: "POST",
    rawBody: { phoneNumber, otp, loginScope: "STAFF" },
  })
}

export async function getMe() {
  return apiFetch<{
    status: string
    data: AuthUser & { sessionExpiresAt: string; lastSeenAt?: string | null }
  }>("/auth/me")
}

export async function logout() {
  return apiFetch<{ status: string; data: { message: string } }>("/auth/logout", {
    method: "POST",
  })
}
